import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { memo, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Pre-split `?tab=` values on the Managed Returns analytics dashboard that now
 * live at standalone /managed-returns pages, mapped to their subpaths.
 */
const LEGACY_TAB_SUBPATHS: Record<string, string> = {
  "inbound-shipments": "inbound-shipments",
  inventory: "inventory",
  "product-catalog": "products",
  tasks: "tasks",
};

/**
 * Redirects legacy analytics-dashboard tab deep links (bookmarks, sent emails)
 * to the standalone pages, preserving remaining query params like locationId.
 */
export const ManagedReturnsTabRedirectGuard = memo(
  function ManagedReturnsTabRedirectGuard({
    children,
  }: {
    children: ReactNode;
  }) {
    const routes = useRequiredContext(MerchantRoutesContext);
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const subPath = LEGACY_TAB_SUBPATHS[params.get("tab") ?? ""];

    if (!subPath) {
      return <>{children}</>;
    }

    params.delete("tab");
    const search = params.toString();
    return (
      <Navigate
        replace
        to={{
          pathname: routes.getManagedReturnsSubRoute(subPath),
          search: search ? `?${search}` : "",
        }}
      />
    );
  },
);
